module.exports = __webpack_public_path__ + "img/pr-1.56ceb2d3.png";